import React, { useState } from 'react';

function AccordionEmployeeTable({data}) {

  const [open, setOpen] = useState(false);

  return (
    <>
      <tr>
        <td className="px-2 first:pl-5 last:pr-5 py-3 whitespace-nowrap">
          <div className="text-left text-indigo-500 font-bold">{data.firstName + " " + data.lastName}</div>
        </td>
        <td className="px-2 first:pl-5 last:pr-5 py-3 whitespace-nowrap">
          <div className="text-left">{data.email}</div>
        </td>
        <td className="px-2 first:pl-5 last:pr-5 py-3 whitespace-nowrap">
          <div className="text-left">{data.title}</div>
        </td>
        {/* <td className="px-2 first:pl-5 last:pr-5 py-3 whitespace-nowrap">
          <div className="text-left text-emerald-500 font-medium">{data.cellNumber}</div>
        </td> */}
        <td className="px-2 first:pl-5 last:pr-5 py-3 whitespace-nowrap w-px">
          <div className="flex items-center">
            <button
              className={`text-slate-400 hover:text-slate-500   ${open && 'rotate-180'}`}
              aria-expanded={open}
              onClick={() => setOpen(!open)}
              aria-controls={`description-${data.id}`}
            >
              <span className="sr-only">Menu</span>
              <svg className="w-8 h-8 fill-current" viewBox="0 0 32 32">
                <path d="M16 20l-5.4-5.4 1.4-1.4 4 4 4-4 1.4 1.4z" />
              </svg>
            </button>
          </div>
        </td>
      </tr>
      {/*
      Example of content revealing when clicking the button on the right side:
      Note that you must set a "colSpan" attribute on the <td> element,
      and it should match the number of columns in your table
      */}
      <tr id={`description-${data.id}`} role="region" className={`${!open && 'hidden'}`}>
        <td colSpan="100%" className="px-2 first:pl-5 last:pr-5 py-3">
          <div className="bg-slate-50   p-3 -mt-3">
            <div className="text-sm mb-3">
              <div className="font-medium text-slate-800  mb-1">{data.descriptionTitle}</div>
                    {/* Employee Form Details */}
                    <section>
                        <ul className='max-w-lg mx-auto'>
                            <li className="md:flex md:justify-between md:items-center py-3 border-b border-slate-200 ">
                                {/* Left */}
                                <div className="text-sm text-slate-800  font-medium">
                                    First Name
                                </div>
                                {/* Right */}
                                <div className="text-sm text-slate-600  ml-4">
                                    <span className="mr-3">{data.firstName}</span>
                                </div>
                            </li>
                            <li className="md:flex md:justify-between md:items-center py-3 border-b border-slate-200 ">
                                {/* Left */}
                                <div className="text-sm text-slate-800  font-medium">
                                    Last Name
                                </div>
                                {/* Right */}
                                <div className="text-sm text-slate-600  ml-4">
                                    <span className="mr-3">{data.lastName}</span>
                                </div>
                            </li>
                            <li className="md:flex md:justify-between md:items-center py-3 border-b border-slate-200 ">
                                {/* Left */}
                                <div className="text-sm text-slate-800  font-medium">
                                    Email
                                </div>
                                {/* Right */}
                                <div className="text-sm text-slate-600  ml-4">
                                    <span className="mr-3">{data.email}</span>
                                </div>
                            </li>
                            <li className="md:flex md:justify-between md:items-center py-3 border-b border-slate-200 ">
                                {/* Left */}
                                <div className="text-sm text-slate-800  font-medium">
                                    Cell Number
                                </div>
                                {/* Right */}
                                <div className="text-sm text-slate-600  ml-4">
                                    <span className="mr-3">{data.cellNumber}</span>
                                </div>
                            </li>
                            <li className="md:flex md:justify-between md:items-center py-3 border-b border-slate-200 ">
                                {/* Left */}
                                <div className="text-sm text-slate-800  font-medium">
                                    Tentative Start Date
                                </div>
                                {/* Right */}
                                <div className="text-sm text-slate-600  ml-4">
                                    <span className="mr-3">{data.tentativeStartDate}</span>
                                </div>
                            </li>
                        </ul>
                    </section> 
                     {/* Show Additional Details */}
                      <div className="rounded-lg shadow-sm border-slate-200  w-full mt-10"> 
                        <h1 className="text-lg text-[#0a1445]  font-medium text-center mb-4">
                          Position and Compensation Information
                        </h1> 
                        <ul className='max-w-lg mx-auto'>
                          <li className="md:flex md:justify-between md:items-center py-3 border-b border-slate-200 ">
                                {/* Left */}
                                <div className="text-sm text-slate-800  font-medium">
                                    Title
                                </div>
                                {/* Right */}
                                <div className="text-sm text-slate-600  ml-4">
                                    <span className="mr-3">{data.title}</span>
                                </div>
                            </li>
                            <li className="md:flex md:justify-between md:items-center py-3 border-b border-slate-200 ">
                                {/* Left */}
                                <div className="text-sm text-slate-800  font-medium">
                                  Employment Type
                                </div>
                                {/* Right */}
                                <div className="text-sm text-slate-600  ml-4">
                                    <span className="mr-3">{data.employementType || "NA"}</span>
                                </div>
                            </li>
                            <li className="md:flex md:justify-between md:items-center py-3 border-b border-slate-200 ">
                                {/* Left */}
                                <div className="text-sm text-slate-800  font-medium">
                                  Compensation Rate
                                </div>
                                {/* Right */}
                                <div className="text-sm text-slate-600  ml-4">
                                    <span className="mr-3">{data.compensationRate ? ('$ ' + data.compensationRate) : "- -"}</span>
                                </div>
                            </li>
                            <li className="md:flex md:justify-between md:items-center py-3 border-b border-slate-200 ">
                                {/* Left */}
                                <div className="text-sm text-slate-800  font-medium">
                                  Is there any type of override or bonus?
                                </div>
                                {/* Right */}
                                <div className="text-sm text-slate-600  ml-4 flex-1 flex justify-end whitespace-normal">
                                    <span className="mr-3 block break-words">{data?.bonus?.value || 'No'}</span>
                                </div>
                            </li>
                            <li className="md:flex md:justify-between md:items-center py-3 border-b border-slate-200 ">
                                {/* Left */}
                                <div className="text-sm text-slate-800  font-medium">
                                  Is there any type of sign-on bonus or upfront incentive?
                                </div>
                                {/* Right */}
                                <div className="text-sm text-slate-600  ml-4 flex-1 flex justify-end whitespace-normal">
                                    <span className="mr-3 block break-words">{data?.upfront?.value || 'No'}</span>
                                </div>
                            </li>
                            <li className="md:flex md:justify-between md:items-center py-3 border-b border-slate-200 ">
                                {/* Left */}
                                <div className="text-sm text-slate-800  font-medium">
                                    Compensation and Other Notes regarding the new hire
                                </div>
                                {/* Right */}
                                <div className="text-sm text-slate-600  ml-4 flex-1 flex justify-end whitespace-normal">
                                    <span className="mr-3 block break-words">{data?.notes || 'NA'}</span>
                                </div>
                            </li>
                        </ul>
                      </div>

                      {/*  Commission Compensation Buckets */}
                      { data?.isShowTransactions && (
                                  <>
                                    <h1 className="text-lg text-[#0a1445]  font-medium text-center mb-4 mt-10">
                                        Commission Compensation Buckets
                                    </h1>
                                    
                                    <div className="rounded-lg shadow-sm border-slate-200  w-full">
                                        <table className="w-full   divide-y divide-slate-200  border-spacing-y-6">
                                            <thead className="text-xs text-gray-700 uppercase bg-gray-50  ">
                                                <tr>
                                                    <th scope="col" className="px-6 py-3 text-left">
                                                        Title
                                                    </th>
                                                    <th scope="col" className="px-6 py-3 ">
                                                        Value
                                                    </th>
                                                    <th scope="col" className="px-6 py-3 ">
                                                        Max Compensation
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody className="text-sm">
                                                {data?.transactions?.map((item, index) => (
                                                    <React.Fragment key={index}>
                                                        <tr className="bg-white border-b  ">
                                                            <th
                                                                scope="row"
                                                                className="text-sm px-6 py-3 font-medium text-gray-900 whitespace-nowrap  text-left"
                                                            >
                                                                {item?.label}
                                                            </th>
                                                            <td className="text-sm px-6 py-3">
                                                                {item?.value || '- -'}
                                                            </td>
                                                            <td className="text-sm px-6 py-3">
                                                                {item.maxCompensation ? ('$ ' + item.maxCompensation) : "- -"}
                                                            </td>
                                                        </tr>
                                                    </React.Fragment>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>

                                  </>
                            )}
            </div>
          </div>
        </td>
      </tr>
    </>
  );
}

export default AccordionEmployeeTable;
